// extracted by mini-css-extract-plugin
module.exports = {"logo":"Sponsor-module--logo--23SVv"};